import {Component, Inject, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import {AdminService} from "../admin.service";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {UserService} from "../../user/user.service";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {KeyValuePipe} from "@angular/common";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {MatOption} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {AdminUser} from "../admin-user";
import {InvitationInstance} from "../invitation-instance";
import {MatCheckbox} from "@angular/material/checkbox";
import {EditUserData} from "../edit-user-data";
import {Role} from "../role";

@Component({
  selector: 'app-admin-edit-user',
  imports: [
    KeyValuePipe,
    MatButton,
    MatDialogContent,
    MatDialogTitle,
    MatFormField,
    MatIcon,
    MatIconButton,
    MatInput,
    MatLabel,
    MatOption,
    MatSelectModule,
    ReactiveFormsModule,
    TranslatePipe,
    MatCheckbox,
    FormsModule,
    MatDialogActions
  ],
  templateUrl: './admin-edit-user.component.html',
  styleUrl: './admin-edit-user.component.scss'
})
export class AdminEditUserComponent implements OnInit {
  detailedUser: AdminUser | undefined;
  userForm: FormGroup;
  countries: any = [];
  editMode: boolean = false;
  groupUserType: Role[] = [];
  groupAccess: Role[] = [];
  groupLevel: Role[] = [];
  groupSpecial: Role[] = [];

  constructor(public ref: MatDialogRef<AdminEditUserComponent>,
              @Inject(MAT_DIALOG_DATA) public data: EditUserData,
              private adminService: AdminService,
              private userService: UserService,
              private translate: TranslateService,
              private fb: FormBuilder) {
    this.userForm = this.fb.group({
      id: ['', []],
      email: ['', [Validators.required, Validators.email]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      company: ['', []],
      username: ['', [Validators.required]],
      department: ['', []],
      jobTitle: ['', []],
      country: ['', []],
      userTypeRoles: ['', []],
      specialRoles: [[], []],
      levelRoles: ['', []],
      accessRoles: [[], []],
      passwordResetRequired: [true, [Validators.required]],
      invitationInstance: ['head', [Validators.required]],
      isActive: [true, [Validators.required]],
    })
  }

  ngOnInit(): void {
    this.getCountries();
    this.clearSelectedRoles();
    if (this.data.userId) {
      this.editMode = true;
      this.userForm.controls['invitationInstance'].clearValidators();
      this.loadUserDetails(this.data.userId);
    }
    if (this.data.userStub) {
      this.setSelectedRoles(this.data.userStub.roles)
    }
  }
  clearSelectedRoles() {
    if (this.data.availableRoles) {
      for (const role of this.data.availableRoles) {
          role.selected = false;
        switch (role.group) {
          case 'user_type':
            this.groupUserType.push(role);
            break;
          case 'level':
            this.groupLevel.push(role);
            break;
          case 'access':
            this.groupAccess.push(role);
            break;
          case 'special_roles':
            this.groupSpecial.push(role);
            break;
        }
      }
    }
  }
  setSelectedRoles(selectedRoles: Role[]) {
    if (this.data.availableRoles) {
      for (const sr of selectedRoles) {
        for (const role of this.data.availableRoles) {
            if (role.name === sr.name) {
              switch (role.group) {
                case 'user_type':
                  this.userForm.patchValue({
                    userTypeRoles: role.name
                  })
                  break;
                case 'level':
                  this.userForm.patchValue({
                    levelRoles: role.name
                  })
                  break;
                case 'access':
                  const vals: string [] = this.userForm.controls['accessRoles'].value;
                  vals.push(role.name);
                  this.userForm.patchValue({
                    accessRoles: vals
                  })
                  break;
                case 'special_roles':
                  const vals2: string [] = this.userForm.controls['specialRoles'].value;
                  vals2.push(role.name);
                  this.userForm.patchValue({
                    specialRoles: vals2
                  })
              }
            }
        }
      }
    }
  }
  patchFormData() {
    if (this.detailedUser) {
      this.userForm.patchValue(this.detailedUser);
    }
  }
  loadUserDetails(id: number) {
    this.adminService.getUser(id).subscribe(res => {
      this.detailedUser = res.data;
      this.setSelectedRoles(this.detailedUser.roles);
      this.patchFormData();
    })
  }
  getCountries() {
    this.userService.getUserCountries(this.translate.defaultLang).subscribe( res => {
      this.countries = res.data;
      this.getRoles()
    })
  }
  getRoles() {
    this.adminService.getRoles().subscribe(res => {
      console.log(res);
    })
  }
  save() {
    const data = this.userForm.value;
    data.roles = this.getFormControlValues();
    console.log('data', data.roles);
    this.ref.close(data);
  }
  close() {
    this.ref.close();
  }
  getFormControlValues(): string[] {
    const roles: string[] = [];
    if (this.userForm.controls['accessRoles'].value) {
      const accessRoles = this.userForm.controls['accessRoles'].value
      for (const entry of accessRoles) {
        roles.push(entry);
      }
    }
    if (this.userForm.controls['specialRoles'].value) {
      const rolesToAdd = this.userForm.controls['specialRoles'].value
      for (const entry of rolesToAdd) {
        roles.push(entry);
      }
    }
    if (this.userForm.controls['userTypeRoles'].value) {
        roles.push(this.userForm.controls['userTypeRoles'].value);
    }
    if (this.userForm.controls['levelRoles'].value) {
      roles.push(this.userForm.controls['levelRoles'].value);
    }
    return roles;

  }

  protected readonly InvitationInstance = InvitationInstance;
}
